export const REFETCH_FINANCIAL = 'refetch-financial';
export const FINANCIAL_DATA_FETCHED = 'financial-fetched';
export const REFETCH_RECEIPTS = 'refetch-receipts';
export const REFETCH_INVOICES = 'refetch-invoices';
export const REFETCH_GOALS = 'refetch-goals';
export const GOALS_DATA_FETCHED = 'goals-fetched';

export type Topic =
	| typeof REFETCH_FINANCIAL
	| typeof FINANCIAL_DATA_FETCHED
	| typeof REFETCH_RECEIPTS
	| typeof REFETCH_INVOICES
	| typeof REFETCH_GOALS
	| typeof GOALS_DATA_FETCHED;
